module.exports = __webpack_public_path__ + "img/bg_no_data.b72cd9b2.png";